<template>
	<div>
		<div v-if="isUserAllowedInLevel1 || isAuthenticatedUserInGroupAdmin">
			<div v-if="doneFetchingCompany">
				<CompanyProfileForm v-model="model" @save="companySave" v-if="!createdNewCompany" :is-edit-modus="isEditModus" :company-type="companyType">
					<template v-if="$route.params.backlink" slot="buttons">
						<div class="w-full flex justify-start">
							<BaseButton @click="$router.push($route.params.backlink)" class="mr-4">{{ $t('general.back') }}</BaseButton>
						</div>
					</template>
					<template v-else-if="isUserAllowedInLevel1">
						<div class="w-full flex justify-start">
							<BaseButton @click="$router.push({ name: 'administrate_companies', type: $route.params.type })" class="mr-4">{{
								$t('general.back')
							}}</BaseButton>
						</div>
					</template>
				</CompanyProfileForm>
			</div>
		</div>
		<div v-else>
			<Forbidden />
		</div>
	</div>
</template>

<script>
import CompanyProfileForm from '@/components/forms/CompanyProfileForm';
import { CompanyApiFactory, InsurancesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden';
import BaseButton from '@/components/forms/buttons/BaseButton';
import LoadingSpinner from '@/mixins/LoadingSpinner';

export default {
	components: { BaseButton, Forbidden, CompanyProfileForm },
	name: 'CompanyProfile',
	mixins: [Authentication, LoadingSpinner],
	data() {
		return {
			model: {
				bankAccount: {},
				ownerFirstname: null,
				ownerLastname: null,
				city: {},
			},
			createdNewCompany: false,
			company: {},
			companyType: 'Firma',
			doneFetchingCompany: false,
		};
	},
	created() {
		if (this.isUserAllowedInLevel1 || this.isAuthenticatedUserInGroupAdmin) {
			this.setCompanyType();
		}
	},
	computed: {
		isUserRequired() {
			return this.$route.params.type !== 'insurance';
		},
		isEditModus() {
			return this.$route.meta.action !== 'new';
		},
		isRepairShopOrCarDealerShip() {
			return this.$route.params.type === 'repairShop' || this.$route.params.type === 'car_dealership';
		},
		userModel() {
			return {
				person: {
					city: this.model.city,
					firstName: this.model.ownerFirstname,
					lastName: this.model.ownerLastname,
					street: this.model.street,
					houseNumber: this.model.houseNumber,
					phoneNumber: this.model.phoneNumber,
					poBox: this.model.poBox,
					cellNumber: this.model.mobileNumber || this.model.phoneNumber,
					gender: this.model.gender,
					company: { id: '' },
				},
				email: this.model.email,
			};
		},
	},
	methods: {
		setCompanyType() {
			switch (this.$route.params.type) {
				case 'damageassessor':
					this.companyType = this.$t('damage_assessor');
					break;
				case 'repairShop':
					this.companyType = this.$t('repair_shop');
					break;
				case 'car_dealership':
					this.companyType = this.$t('car_shop');
					break;
				case 'lawyerOffice':
					this.companyType = this.$t('lawyers_office');
					break;
				case 'insurance':
					this.companyType = this.$t('insurance');
					break;
				case 'insuranceoffice':
					this.companyType = this.$t('insurance_office');
					break;
				case 'agent_pool':
					this.companyType = this.$t('mediator');
					break;
			}
		},
		companySave(company) {
			this.createdNewCompany = true;
			this.$emit('scrollUp');
			this.company = company;

			if (!this.isUserRequired) {
				this.onlySaveCompany();
				this.$store.commit('setConfirmLeaving', false);
			}
		},
		getCompanyProfileData(id) {
			CompanyApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.companyIdGet(id)
				.then(response => {
					this.model = response.data;
					this.model.company_relationship_type = response.data.company_relationship_type;
					this.doneFetchingCompany = true;
				})
				.catch(error => {});
		},
		onlySaveCompany() {
			InsurancesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.insurancesPost(this.company)
				.then(response => {
					this.$swal(this.$t('general.success').toString(), this.$t('add_company', { company: this.companyType }).toString(), 'success').then(() => {
						this.$router.push({ name: 'administrate_companies', type: this.$route.params.type });
					});
				})
				.catch(error => {
					this.$swal(this.$t('general.error').toString(), this.$t('add_company_error', { company: this.companyType }).toString(), 'error');
				});
		},
	},
	mounted() {
		const payload = this.$route.params.payload;
		if (this.$route.meta.action !== 'new') {
			this.getCompanyProfileData(this.$route.params?.id || this.getUser.person?.company?.company_id || this.getUser.person?.company?.id);
		} else if (this.$route.params.payload) {
			this.model.ownerFirstname = payload.firstName;
			this.model.ownerLastname = payload.lastName;
			this.model.name = payload.company || payload.name;
			this.model.city = { id: payload.city.id, zipCode: payload.city.zip_code, name: payload.city.name };
			this.model.title = payload.title;
			this.model.gender = payload.gender;
			this.model.street = payload.street;
			this.model.poBox = payload.poBox;
			this.model.phoneNumber = payload.phone;
			this.model.houseNumber = payload.houseNumber;
			this.model.email = payload.email;
			this.doneFetchingCompany = true;
		} else {
			this.doneFetchingCompany = true;
		}
	},
};
</script>

<style scoped></style>
